import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSpam = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1C4.136 1 1 4.136 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1ZM11.5 8.7H4.5V7.3H11.5V8.7Z",
		fill: "#4384F5"
	})
});
export default SvgSpam;
